import { ColorScheme, MindmapStyle } from '@blocksuite/affine-model';
import type { TemplateResult } from 'lit';

import { type DraggableTool, getMindmapRender } from './basket-elements.js';
import {
  mindMapStyle1Dark,
  mindMapStyle1Light,
  mindMapStyle2Dark,
  mindMapStyle2Light,
  mindMapStyle3,
  mindMapStyle4,
  mindMapStyle5,
  mindMapStyle6,
  mindMapStyle7,
  mindMapStyle8,
} from './icons.js';

export type ToolbarMindmapItem = {
  type: 'mindmap';
  icon: TemplateResult;
  style: MindmapStyle;
  render: DraggableTool['render'];
};

export const getMindMaps = (theme: ColorScheme): ToolbarMindmapItem[] => [
  {
    type: 'mindmap',
    icon: theme === ColorScheme.Dark ? mindMapStyle1Dark : mindMapStyle1Light,
    style: MindmapStyle.ONE,
    render: getMindmapRender(MindmapStyle.ONE, 0, 1), // Right layout, depth 1
  },
  {
    type: 'mindmap',
    icon: theme === ColorScheme.Dark ? mindMapStyle2Dark : mindMapStyle2Light,
    style: MindmapStyle.TWO,
    render: getMindmapRender(MindmapStyle.TWO, 0, 1),
  },
  {
    type: 'mindmap',
    icon: mindMapStyle3,
    style: MindmapStyle.THREE,
    render: getMindmapRender(MindmapStyle.THREE, 0, 1),
  },
  {
    type: 'mindmap',
    icon: mindMapStyle4,
    style: MindmapStyle.FOUR,
    render: getMindmapRender(MindmapStyle.FOUR, 0, 1),
  },
  {
    type: 'mindmap',
    icon: mindMapStyle5,
    style: MindmapStyle.FIVE,
    render: getMindmapRender(MindmapStyle.FIVE, 0, 1),
  },
  {
    type: 'mindmap',
    icon: mindMapStyle6,
    style: MindmapStyle.SIX,
    render: getMindmapRender(MindmapStyle.SIX, 0, 1),
  },
  {
    type: 'mindmap',
    icon: mindMapStyle7,
    style: MindmapStyle.SEVEN,
    render: getMindmapRender(MindmapStyle.SEVEN, 0, 1),
  },
  {
    type: 'mindmap',
    icon: mindMapStyle8,
    style: MindmapStyle.EIGHT,
    render: getMindmapRender(MindmapStyle.EIGHT, 0, 1),
  },
];
